
import React from 'react';
import { Col, Row, Nav, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import {
  IoIosChatboxes
} from "react-icons/io";

import UserDropdown from './UserDropdown';
import withNavigationUserProps from './withNavigationUserProps';

function UserNav({ userId, userIsNew, userPathString }) {
  if (userIsNew) {
    return null;
  }
  return (
    <Nav as="ul" className="flex-grow-1">
      <Row className="small-gutters flex-grow-1">
        <Col xs="auto">
          <Row className="small-gutters">
            <Col xs="auto" className="mb-1">
              <LinkContainer to={`/users/${userPathString}`} exact>
                <Button size="md" variant="outline-secondary">
                  <IoIosChatboxes size="1.2em" /> <span>Activity</span>
                </Button>
              </LinkContainer>
            </Col>
          </Row>
        </Col>
        <Col xs="auto" className="ml-auto">
          <Row className="small-gutters">
            <Col xs="auto" className="mb-1">
              <UserDropdown userId={userId} />
            </Col>
          </Row>
        </Col>
      </Row>
    </Nav>
  );
}

export default withNavigationUserProps(UserNav);
